var SamplingNeedsGridComponent = /** @class */ (function () {
    function SamplingNeedsGridComponent() {
    }
    Object.defineProperty(SamplingNeedsGridComponent.prototype, "displayGrowthStage", {
        get: function () {
            return this.requestedSamplings.some(function (r) { return r.growthStage !== null; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SamplingNeedsGridComponent.prototype, "displayDaysAfterPlanting", {
        get: function () {
            return this.requestedSamplings.some(function (r) { return r.daysAfterPlanting !== null; });
        },
        enumerable: true,
        configurable: true
    });
    return SamplingNeedsGridComponent;
}());
export { SamplingNeedsGridComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/sampling-needs-grid/sampling-needs-grid.component.ts.pre-build-optimizer.js